export const MOBILE_SERVER_PRODUCTS = 4
export const DESKTOP_SERVER_PRODUCTS = 8
export const AFTER_FILTER_PRODUCTS = 20
